module.exports = __webpack_public_path__ + "static/media/correct_choice.048a50bb.svg";